// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"cdadb1a1","760":"c44d697c"}[chunkId] + ".chunk.js";
};